import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { NavigationComponent } from './navigation/navigation.component';
import { BreadcrumbsComponent } from './breadcrumbs/breadcrumbs.component';
import { AuthModule } from '../../modules/auth/auth.module';
import { DefaultLayoutComponent } from './default-layout.component';
import { RouterModule } from '@angular/router';
import {ConfirmationDialogComponent} from "./confirmationDialog/confirmation-dialog.component";

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    AuthModule
  ],
  declarations: [
    BreadcrumbsComponent,
    HeaderComponent,
    FooterComponent,
    NavigationComponent,
    DefaultLayoutComponent,
    ConfirmationDialogComponent
  ],
  exports: [
    BreadcrumbsComponent,
    HeaderComponent,
    FooterComponent,
    NavigationComponent,
    DefaultLayoutComponent,
    ConfirmationDialogComponent
  ]
})
export class DefaultLayoutModule {
}
